module.exports = __webpack_public_path__ + "img/esquema.c6f81be8.jpg";